// Вид гридов текущего пользователя: порядок колонок и скрытые колонки.
// Живёт на сервере, а не в localStorage, чтобы настроенный вид переезжал
// между компьютерами и браузерами.
import { apiDelete, apiGet, apiPut } from '../api-client/index.js';
import { entityListKey, type EntityListKey } from '../api/entityQueryKeys.js';

export interface GridProfileItem {
  grid: string;
  order: string[];
  hidden: string[];
}

export interface SaveGridProfileInput {
  order: string[];
  hidden: string[];
}

export function getGridProfilesQueryKey(workspaceId: string): EntityListKey {
  return entityListKey('grid-profiles', workspaceId);
}

export async function listGridProfiles(): Promise<GridProfileItem[]> {
  return apiGet<GridProfileItem[]>('/grid-profiles');
}

export async function saveGridProfile(
  grid: string,
  input: SaveGridProfileInput,
): Promise<GridProfileItem> {
  return apiPut<GridProfileItem, SaveGridProfileInput>(`/grid-profiles/${grid}`, input);
}

export async function resetGridProfile(grid: string): Promise<void> {
  return apiDelete(`/grid-profiles/${grid}`);
}
